import { TableBody } from 'module/ui/components/molecules/draggable-table/styles';
import { BodyShort01 } from 'module/ui/ozone/atoms/typography';
import styled from 'styled-components';

export const StyledDraggableTable = styled.div`
  width: 100%;

  ${TableBody} {
    overflow-y: auto;
    overflow-x: auto;
  }
`;

export const SignalName = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
`;

export const CompanyName = styled(SignalName)`
  max-width: 200px;
`;

export const Reason = styled(SignalName)`
  max-width: 200px;
`;

export const SaidBy = styled(BodyShort01)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
`;

export const Role = styled(SignalName)`
  max-width: 75px;
`;

export const CreatedOn = styled(SignalName)`
  max-width: 75px;
`;
